<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>Acknowledgments</b></div>
<div class="fmtx1">We are profoundly indebted to the many generous, thoughtful individuals and organizations who helped us form and improve this book—by sharing their hard-won knowledge, by reviewing and editing the manuscript in progress, and by granting us permission to reprint materials. They include: Sandra Adams, ACFRE; Ron Arena; Tracey Biles; Jeff Brooks; Lisa Bousquet; Penelope Burk; Marcia Coné-Tighe; Marci Cornell Feist; Sarah Coviello, CFRE; Patty Dowling; Jon Duschinsky; Peter Duschinsky; Carol Golden; Kathe Grooms; Nisia Hanson; Ted Hart, ACFRE; Sally Kirby Hartman; Kris Hermanns; Morgean Hirt, ACA; Jim Hoyt; Dianna Huff; Louise Jakobson; Patricia Kern; Guy Mallabone, CFRE; Ari Matusiak; Rose McIlvane; Harvey McKinnon; Barbara Mulville, CFRE; Tony Myers, CFRE; Tina Palmer, CFRE; Jerry Panas; Bob Parks; Shawn Poland; Jim Rattray; Martha Rennie, CFRE; Susan Rice, ACFRE; Richard Radcliffe; Adrian Sargeant and Elaine Jay; Gene Scanlan, CFRE; Rick Schwartz; Steve Slaten; Lisa Smolski; Larry Taft; Clovis Thorn; Phil Valentine; Nondas Hurst Voll; Mal Warwick; Colin Wheildon; Alexcia WhiteCrow, CFRE; and Wendy Zufelt-Baxter.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// aher_9781118044865_oeb_ack_r1.vue?c6f79e16